// @flow
import { createSelector } from 'reselect';

import type { AppState } from '../../statsradio/types/State';

export const getState = (state: AppState): AppState => state;

export const getFeaturePermissions = createSelector(getState, state => (state.session.radio ? state.session.radio.featurePermissions : []));



// WEBPACK FOOTER //
// ./src/common/reducers/FeaturePermissionSelectors.js